import { startOfWeek, endOfWeek, eachDayOfInterval } from "date-fns";
import type { Routine } from "instantdb/types";
import { hasDayCompleted, isRoutineActiveForDate } from "@/hooks/routines/useRoutine.utils";
import { extractDateFromDate } from "@/utilities/dateFormatter";

interface WeeklyStats {
  totalCompleted: number;
  totalExpected: number;
  completionPercentage: number;
  weekStart: Date;
  weekEnd: Date;
}

export function calculateWeeklyStats(
  routines: Routine[],
  selectedDate: Date,
  weekStartsOn: 0 | 1 = 1,
): WeeklyStats {
  const weekStart = startOfWeek(selectedDate, { weekStartsOn });
  const weekEnd = endOfWeek(selectedDate, { weekStartsOn });
  const daysInWeek = eachDayOfInterval({ start: weekStart, end: weekEnd });

  // Filter routines that are active for this week
  const weekActiveRoutines = routines.filter((routine) =>
    daysInWeek.some((day) => isRoutineActiveForDate(routine, extractDateFromDate(day))),
  );

  let totalCompleted = 0;
  let totalExpected = 0;

  for (const day of daysInWeek) {
    const dayString = extractDateFromDate(day);
    for (const routine of weekActiveRoutines) {
      if (isRoutineActiveForDate(routine, dayString)) {
        totalExpected++;
        if (hasDayCompleted(routine, dayString)) {
          totalCompleted++;
        }
      }
    }
  }

  const completionPercentage =
    totalExpected > 0 ? Math.round((totalCompleted / totalExpected) * 100) : 0;

  return {
    totalCompleted,
    totalExpected,
    completionPercentage,
    weekStart,
    weekEnd,
  };
}
